import { uniqueId, snakeCase } from "lodash";
import React from "react";
import PropTypes from "prop-types";
import Tab from "react-bootstrap/Tab";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Nav from "react-bootstrap/Nav";
import CustomDropdownMenu from "./CustomDropdownMenu";

class TabDropdownMenu extends React.Component {
  constructor(props) {
    super(props);
    const activeMenuItem = props.menuItems[props.activeIndex];
    this.state = {
      activeIndex: props.activeIndex,
      showContent: activeMenuItem && activeMenuItem.content
    };
    this.performChange = this.performChange.bind(this);
    this.handleChange = this.handleChange.bind(this);
  }

  performChange(menuItem, idx, e) {
    this.props.onSelect(idx, e);
    this.props.handleClick(menuItem, e);
  }

  handleChange(e, menuItem, idx) {
    if (e) {
      e.preventDefault();
    }

    const newState = {
      activeIndex: idx,
      showContent: false
    };

    // handle onSelect, and handleClick in content
    if (menuItem.content) {
      newState.showContent = true;
    } else {
      this.performChange(menuItem, idx, e);
    }

    this.setState(newState);
  }

  render() {
    const { showContent, activeIndex } = this.state;
    const { menuItems, field } = this.props;

    return (
      <CustomDropdownMenu
        customStyle={
          showContent
            ? {
                width:
                  this.props.customMenuStyles?.menuWithContentWidth ?? "360px"
              }
            : null
        }
        {...this.props}
        ref={this.props.innerRef}
      >
        <Tab.Container
          id={`tab-dropdown-${uniqueId()}`}
          className="container-fluid"
          defaultActiveKey={activeIndex}
        >
          <Row className="clearfix">
            <Col
              xs={
                showContent
                  ? this.props.customMenuStyles?.menuColumnSize ?? 5
                  : 12
              }
            >
              <Nav
                variant="tabs"
                className="flex-column"
                activeKey={activeIndex}
              >
                {menuItems.map((menuItem, idx) => (
                  <Nav.Item key={idx}>
                    <Nav.Link
                      eventKey={idx}
                      data-testid={snakeCase(
                        `dropdown_${field}_menu_item_${menuItem.value}`
                      )}
                      onClick={e => this.handleChange(e, menuItem, idx)}
                    >
                      {menuItem.label}
                    </Nav.Link>
                  </Nav.Item>
                ))}
              </Nav>
            </Col>
            {showContent && (
              <Col
                xs={this.props.customMenuStyles?.contentColumnSize ?? 7}
                className="tab-content__container"
              >
                <Tab.Content>
                  {menuItems.map(
                    (menuItem, idx) =>
                      menuItem.content && (
                        <Tab.Pane key={idx} eventKey={idx}>
                          {menuItem.content({
                            closeMenu: e => this.performChange(menuItem, idx, e)
                          })}
                        </Tab.Pane>
                      )
                  )}
                </Tab.Content>
              </Col>
            )}
          </Row>
        </Tab.Container>
      </CustomDropdownMenu>
    );
  }
}

TabDropdownMenu.propTypes = {
  activeIndex: PropTypes.number,
  onSelect: PropTypes.func,
  handleClick: PropTypes.func,
  menuItems: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
      value: PropTypes.any,
      content: PropTypes.func
    })
  ),
  customMenuStyles: PropTypes.shape({
    menuWithContentWidth: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number
    ]),
    menuColumnSize: PropTypes.number,
    contentColumnSize: PropTypes.number
  })
};

TabDropdownMenu.defaultProps = {
  activeIndex: 0,
  onSelect: () => {},
  handleClick: () => {},
  menuItems: []
};

export default React.forwardRef((props, ref) => (
  <TabDropdownMenu innerRef={ref} {...props} />
));
